import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "display-price__vat-setting"
}
const _hoisted_2 = {
  key: 0,
  class: "display-price__vat-setting"
}
const _hoisted_3 = { class: "display-price__original-price" }
const _hoisted_4 = {
  key: 2,
  class: "display-price__discount-percentage"
}

import { computed } from 'vue';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayPrice',
  props: {
  originalPrice: {
    type: Number,
    required: true,
  },
  campaignPrice: {
    type: Number,
    default: undefined,
  },
  locale: {
    type: String,
    default: '',
  },
  currency: {
    type: String,
    default: '',
  },
  verticalStack: {
    type: Boolean,
    default: false,
  },
  invertPrices: {
    type: Boolean,
    default: false,
  },
  multiPrice: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const { formatPrice } = useContext();
const { websiteText } = useWebsiteTexts();

const confirmCampaignExists = computed(() => {
  return (
    props.originalPrice &&
    props.campaignPrice &&
    props.campaignPrice !== 0
  );
});


const confirmCampaignIsLower = computed(() => {
  return  props.campaignPrice < props.originalPrice;
});

const discountPercentage = computed(() => {
  let discount =
    ((props.originalPrice - (props.campaignPrice || 0)) / props.originalPrice) *
    100;
  discount = Math.round(+discount.toFixed(2));
  return `-${discount.toString()}%`;
});

function fixPrice(price: any) {
  if (price) {
    if (!props.multiPrice) {
      return formatPrice(price);
    }

    return websiteText('global_from', { price: formatPrice(price) }).value;
  }

  return price || '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['display-price', { 'display-price--vertical': __props.verticalStack }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'display-price__campaign-price-wrap',
        {
          'display-price__campaign-price-wrap--with-campaign':
            _unref(confirmCampaignExists),
        },
        {
          'display-price__campaign-price-wrap--no-campaign':
            !_unref(confirmCampaignExists),
        },
      ])
    }, [
      (_unref(confirmCampaignExists))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["display-price__campaign-price", [{ 'display-price__campaign-price--inverted': __props.invertPrices }]])
          }, _toDisplayString(fixPrice(__props.campaignPrice)), 3))
        : _createCommentVNode("", true),
      (!_unref(confirmCampaignExists))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(websiteText)('product__excluding_vat').value), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([
        'display-price__original-price-wrap',
        {
          'display-price__original-price-wrap--with-campaign':
            _unref(confirmCampaignExists),
        },
        {
          'display-price__original-price-wrap--no-campaign':
            !_unref(confirmCampaignExists),
        },
      ])
    }, [
      (_unref(confirmCampaignExists))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(websiteText)('product__excluding_vat').value), 1))
        : _createCommentVNode("", true),
      (_unref(confirmCampaignIsLower))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          'display-price__original-price-item',
          { 'display-price__original-price--disabled': _unref(confirmCampaignExists) },
          { 'display-price__original-price--inverted': __props.invertPrices },
        ])
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(fixPrice(__props.originalPrice)), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_unref(confirmCampaignIsLower))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(discountPercentage)), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})